import React from "react";
import useWebSocket from "react-use-websocket";

const Websocket = ({ token }) => {
  const { sendMessage } = useWebSocket(
    process.env.RAZZLE_APP_WS + "?token=" + token,
    {
      shouldReconnect: () => true,
      onOpen: () => {
        setInterval(() => {
          sendMessage("ping");
        }, 10000);
      },
      share: true,
      onMessage: (/*message*/) => {
        // const data = JSON.parse(message.data);
        // toast({
        //   title: "Test notification",
        //   description: "Test",
        //   status: "success",
        //   duration: 3000,
        //   isClosable: true,
        // });
        // if (data.type === "notification") {
        //   const notification = this.api.transformNotification(message);
        //   const notificationMessage = this.getNotificationMessage(
        //     notification.type
        //   );
        //   if (notificationMessage) {
        //     this.dispatch(appSnackbarMessage({ message: notificationMessage }));
        //   }
      },
    },
  );

  return <></>;
};

export default Websocket;
